module.exports = __webpack_public_path__ + "static/media/Mercedes-Benz4.b606a500.mp3";